const soap = {
    "92":"Такого пользователя не существует",
    "10":"Неправильно указан логин и пароль",
    "142":"Не указана фамилия",
    "141":"Не указан пароль",
    "140":"Не указан адрес эл. почты",
    "96":"Пользователь с таким адресом эл. почты уже существует!",
    "411":"Не удалось авторизироваться - неизвестная ошибка",
    "419":"Не удалось авторизироваться - системная ошибка. Отсутствует настройка",
    "421":"Не удалось авторизироваться - отсутствует код авторизации",
    "423":"Не удалось авторизироваться - не удалось получить токен",
    "424":"Не удалось авторизироваться - не удалось получить информацию о пользователе",
    "425":"Не удалось авторизироваться - не удалось выполнить запрос пользователя",
    "426":"Не удалось создать пользователя - такой логин или адрес почты уже существует",
    "427":"Не удалось создать пользователя - такой адрес электронной почты уже зарегистрирован",
    "428":"Не удалось создать пользователя - такой номер телефона уже зарегистрирован",
    "430":"Техническая ошибка - не удалось получить идентификатор сессии. Попробуйте авторизироваться",
    "611":"Транзакция отклонена - Проверьте реквизиты карты или обратитесь в ваш банк",
    "612":"Транзакция отклонена",
    "613":"Транзакция отклонена - не хватает средств",
    "615":"Транзакция отклонена - ошибка 3D Secure. Пожалуйста, обратитесь в ваш банк",
    "411":"Пользователь не существует. Пожалуйста, <a href='{link}'>зарегистрируйтесь</a>, сначала.",
    "712":"Пожалуйста, заполните поле \"Цель\"",
    "713":"Пожалуйста, заполните поле \"Имя\"",
    "714":"Адрес почты не может быть пустым",
    "715":"Номер телефона не может быть пустым",
    "716":"Пожалуйста, укажите имя родителя",
    "717":"Пожалуйста, укажите ваш возраст",
    "916":"Не удалось обновить профиль - такой адрес электронной почты уже существует",
    "918":"Не удалось подключить профиль. Возможно этот профиль уже привязан к другому пользователю, пожалуйста обратитесь в поддержку"
};
export default soap